import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    NumberInput,
    SelectInput,
    DateInput,
    BooleanInput,
    ReferenceInput,
    AutocompleteInput,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    ArrayInput,
    FileInput,
    FileField,
    SimpleFormIterator
} from 'react-admin';
import { getFieldsForRessource } from '../utils/fieldsForRessource';
import dateUtils from '../utils/dateUtils';
import utils from '../utils/utils';

const redirect = (basePath, id, data) => `${basePath}`;


class CustomTableCreate extends React.Component {
    state = { data: null }

    customHandled(fields, fieldName, fieldList, parentFieldName) {
        return false;
    }

    generateFromFields(fields, parentFieldName) {
        const that = this;

        const fieldList = [];
        for (const fieldName in fields) {
            let fieldLabel = fieldName.replace(/([A-Z])/g, ' $1').trim();
            fieldLabel = fieldLabel.charAt(0).toUpperCase() + fieldLabel.slice(1);
            if (!this.customHandled(fields, fieldName, fieldList, parentFieldName)) {

                if (fields[fieldName].type === 'String' && fields[fieldName].enum !== undefined) {
                    fieldList.push(<SelectInput label={fieldLabel} source={fieldName} choices={this.transformInChoices(fields[fieldName].enum)} kwy={fieldLabel} />);
                } else if (fields[fieldName].type === 'String') {
                    fieldList.push(<TextInput label={fieldLabel} source={fieldName} key={fieldLabel}/>);
                } else if (fields[fieldName].type === 'Number') {
                    fieldList.push(<NumberInput label={fieldLabel} source={fieldName} key={fieldLabel}/>);
                } else if (fields[fieldName].type === 'Date') {
                    // fieldList.push(<DateInput label={fieldName} source={fieldName} format={dateUtils.dateFormatter} parse={dateUtils.dateParser} />)
                    fieldList.push(<DateInput label={fieldLabel} source={fieldName} parse={dateUtils.dateParser} key={fieldLabel} />);
                } else if (fields[fieldName].type === 'Boolean') {
                    fieldList.push(<BooleanInput label={fieldLabel} source={fieldName} key={fieldLabel} />);
                } else if (fields[fieldName].type === 'ObjectId') {
                    const plural = utils.getPlural(fields[fieldName].ref);
                    fieldList.push(<ReferenceInput label={fieldLabel} source={fieldName} reference={plural} allowEmpty key={fieldLabel}>
                        <AutocompleteInput optionText={utils.displayFieldForPlural(plural)} />
                    </ReferenceInput>);
                } else if (fields[fieldName].type === 'Object') {

                    fieldLabel += ' (max: 20Mb)';
                    fieldList.push(<FileInput source={fieldName} label={fieldLabel}>
                        <FileField source="src" title="title" key={fieldLabel} />
                    </FileInput>);
                } else if (Array.isArray(fields[fieldName].type)) {

                    if (fields[fieldName].type[0].type === 'ObjectId') {
                        const plural = utils.getPlural(fields[fieldName].type[0].ref);

                        fieldList.push(<ReferenceArrayInput label={fieldLabel} source={fieldName} reference={plural} allowEmpty key={fieldLabel}>
                            <AutocompleteArrayInput optionText={utils.displayFieldForPlural(plural)} />
                        </ReferenceArrayInput>);
                    } else {

                        var subObject;
                        if (fields[fieldName].type[0].children) {
                            subObject = that.generateFromFields(fields[fieldName].type[0].children, fieldName);

                            fieldList.push(<ArrayInput source={fieldName} key={fieldLabel}>
                                <SimpleFormIterator>
                                    {subObject}
                                </SimpleFormIterator>
                            </ArrayInput>);
                        } else {
                            subObject = that.generateFromFields(fields[fieldName].type, fieldName);

                            fieldList.push(<ArrayInput source={fieldName} key={fieldLabel}>
                                <SimpleFormIterator>
                                    {subObject}
                                </SimpleFormIterator>
                            </ArrayInput>);
                        }

                    }
                    // fieldList.push(<ReferenceArrayInput label={fieldName} source={fieldName} reference={fieldName} allowEmpty>
                    //         {/* <ChipField source="name" /> */}
                    //         <SelectArrayInput optionText="name" />
                    // </ReferenceArrayInput>)
                }
            }
        }

        return fieldList;
    }

    componentDidMount() {
        const that = this;
        return getFieldsForRessource(this.props.resource).then((fields) => {

            const fieldList = that.generateFromFields(fields, null);

            this.setState({
                data: <Create {...this.props}>
                    <SimpleForm redirect={redirect}>
                        {fieldList}
                    </SimpleForm>
                </Create>
            });
        });
    }

    render() {

        if (!this.state.data) {
            return <div />;
        }

        return this.state.data;
    }

    transformInChoices(base) {
        const returnObject = [];
        for (const obj in base) {
            if (base[obj]) {
                returnObject.push({
                    'id': base[obj],
                    'name': base[obj]
                });
            } else {
                returnObject.push({
                    'id': null,
                    'name': 'None'
                });
            }
        }
        return returnObject;
    }

    transformInChoicesWithout(base, avoidList) {
        const returnObject = [];
        for (const obj in base) {
            if (avoidList.indexOf(base[obj]) === -1) {
                returnObject.push({
                    'id': base[obj],
                    'name': base[obj]
                });
            }
        }
        return returnObject;
    }
}

export default CustomTableCreate;